"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useNavigationEvent;

var _router = _interopRequireDefault(require("next/router"));

var _react = require("react");

function useNavigationEvent(cb) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  (0, _react.useEffect)(function () {
    _router["default"].events.on('routeChangeStart', cb);

    return function () {
      return _router["default"].events.off('routeChangeStart', cb);
    };
  }, []);
}
